import { TextAnimator } from './text-animator.js'

export function boostTerminalLikeHover() {
    document.querySelectorAll('.terminal-like-hover').forEach((item) => {
        const animator = new TextAnimator(item)
        item.addEventListener('mouseenter', () => {
            animator.animate()
        })
    })
}
